import React, { useEffect, useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeXmark, faPlay } from '@fortawesome/free-solid-svg-icons';
import {
  selectIsConnectedToRoom,
  useHMSActions,
  useHMSNotifications,
  useHMSStore,
  useParticipants,
  HMSNotificationTypes,
} from '@100mslive/react-sdk';

import AuthContext from 'app/src/contexts/AuthContext';
import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

import AudioStream from './AudioStream';
import { Subtitle, Button } from './elements';

export const Container = styled(View)`
  flex-direction: row;
  align-items: baseline;
  justify-content: space-around;
`;

export const ButtonContainer = styled(Pressable)`
  background-color: ${colors.elGreen}
  flex-direction: row;
  padding: 10px;
  align-items: center;
  justify-content: space-around;
  gap: 20px;
  min-width: 300px;
`;

function NewStream({ userName, roomCode, producer, sale, setIsConnected }) {
  const { currentUser } = useContext(AuthContext);
  const [connecting, setConnecting] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const hmsActions = useHMSActions();
  const { participants: broadcasters } = useParticipants({
    role: 'broadcaster'
  });

  const activeStream = broadcasters.length > 0;

  const hmsNotification = useHMSNotifications(HMSNotificationTypes.ERROR);

  if (currentUser?.fullName) {
    userName = `${userName}-${currentUser.id} - ${currentUser.fullName}`;
  }

  useEffect(() => {
    if (!sale?.bidding && isConnected) {
      setConnecting(false);
      hmsActions.leave();
    }
  }, [sale?.bidding]);

  useEffect(() => {
    window.onunload = () => {
      if (isConnected) {
        hmsActions.leave();
      }
    };
  }, [hmsActions]);

  useEffect(() => {
    return () => { hmsActions.leave(); }
  }, []);

  const unblock = async () => {
    setBlocked(true);
    await hmsActions.unblockAudio();
  };

  useEffect(() => {
    if (!hmsNotification) { return; }

    if (HMSNotificationTypes.ERROR === hmsNotification.type) {
      if ('AutoplayBlocked' === hmsNotification.data.name) {
        unblock();
      }
    };
  }, [hmsNotification]);


  const join = async (e) => {
    setConnecting(true);
    if (setIsConnected) { setIsConnected(true); }

    const authToken = await hmsActions.getAuthTokenByRoomCode({ roomCode })

    try {
      await hmsActions.join({ userName, authToken });
    } catch (e) {
      console.error(e)
    }
  };

  const leave = () => {
    setConnecting(false);
    if (setIsConnected) { setIsConnected(false); }

    hmsActions.leave();
  }

  let active = 'Audio Stream Not Active';
  let play = 'Click to Play Audio';
  let playing = 'Audio will play when Available';

  if (!isConnected) {
    active = '';
  } else if (activeStream) {
    active = 'Audio Stream Active';
    play = 'Click to Play Audio';
    playing = 'Playing Audio';
  }

  const title = isConnected ?
    'Stop Transmitting Audio' :
    (connecting ? 'Connecting...' : 'Start Transmitting Audio Stream');

  if (producer) {
    return (
      <Container>
        {sale?.bidding && (
          <Button
            title={title}
            onPress={() => isConnected ? leave() : join()}
            color={isConnected ? null : 'gray'}
            style={{ maxHeight: 50 }}
          />
        )}
      </Container>
    );
  }

  if (!sale?.bidding) {
    return null;
  }

  return (
    <Container>
      <Subtitle>{active}</Subtitle>
      {blocked ? (
        <>
          <Text>Audio has been blocked by your browser.</Text>
          <input
            type="button"
            value="Click to Unblock"
            onClick={() => {
              hmsActions.unblockAudio();
              setBlocked(false);
            }}
            style={{ fontSize: 20 }}
          />
        </>
      ) : (
        isConnected ? (
          <ButtonContainer onPress={leave}>
            <Text style={{ color: 'white' }}>{playing}</Text>
            <FontAwesomeIcon
              icon={faVolumeXmark}
              title="Stop Audio"
              color="white"
            />
          </ButtonContainer>
        ) : (
          <ButtonContainer
            onPress={join}
            style={{ backgroundColor: 'lightgray' }}
          >
            <Text>{connecting ? 'Connecting...' : play}</Text>
            <FontAwesomeIcon
              icon={faPlay}
              title="Play Audio"
            />
          </ButtonContainer>
        )
      )}
    </Container>
  );
}

export default NewStream;
